import * as nt from 'neverthrow';

type AuthError = {
  type:
    'UserTokenRetrieval' | 'ClientTokenRetrieval' | 'GuestTokenRetrieval' | 'Cancelled' | 'NoUser';
  message: string;
  /** Set when the sign-in behind the session is gone, rather than this one attempt having failed.
   *  Only a provider that has been told so can say it; a server that is merely unwell leaves it
   *  unset, so a bad minute does not sign anybody out. */
  signInGone?: boolean;
};

type Result<T> = nt.Result<T, AuthError>;

/**
 * Used to create an error and automatically wrap the error message with a Date
 *
 * @param type Type of `AuthError`
 * @param message Descriptive error message
 * @param options `signInGone` when the sign-in behind the session is gone, not just this attempt.
 *   Named rather than positional: a bare `true` at a call site says nothing about what is true.
 * @returns
 */
function authErr(
  type: AuthError['type'],
  message: string,
  options: { signInGone?: boolean } = {},
): nt.Err<never, AuthError> {
  return nt.err({
    type,
    message: `${message} - ${new Date().toLocaleString('sv')}`,
    signInGone: options.signInGone,
  });
}

export { authErr };
export type { Result, AuthError };
